import type { FC } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

interface Props {
  // 申诉 justice | 举报 report
  type: 'justice' | 'report';
  onCloseModal(): void;
  email?: string;
  success: boolean;
}

export const AppealResult: FC<Props> = ({ type, onCloseModal, success, email }) => {
  const { t } = useAppTranslation();
  const IS_JUSTICE = type === 'justice';

  return (
    <div className="flex w-[400px] sm:w-full items-center flex-col p-7">
      <div className="text-7xl md:text-3xl">{success ? '😀' : '😔'}</div>
      <div className="my-2.5 font-medium">
        {IS_JUSTICE &&
          (success ? t('share.appeal.success_justice') : t('share.appeal.pending_justice'))}
        {!IS_JUSTICE &&
          (success ? t('share.appeal.success_report') : t('share.appeal.pending_report'))}
      </div>
      <div className="text-t2 text-center mb-7">
        <div>
          {IS_JUSTICE &&
            (success ? t('share.appeal.justice_email_tip') : t('share.appeal.justice_try_tip'))}
          {!IS_JUSTICE &&
            (success ? t('share.appeal.report_support_tip') : t('share.appeal.report_limit_tip'))}
        </div>
        <div className="text-center text-active_color">{IS_JUSTICE && success && email}</div>
      </div>
      <div
        onClick={onCloseModal}
        className="w-full animate-click bg-black text-center text-t2 py-1.5 text-white1 rounded"
      >
        {t('common.got_it')}
      </div>
    </div>
  );
};
